<template>
  <div class="container">
    <div class="tabs">
      <div class="title">生长监测</div>
      <div class="tabWrap">
        <van-tabs key="grow" v-model="acTab" title-active-color="#3364DB" @change="handleTabsChange">
          <van-tab v-for="item in tabs" v-if="item.show" :key="item.key" :name="item.key" :title="item.name"></van-tab>
        </van-tabs>
      </div>

    </div>

    <div class="body">
      <div class="wrap">
        <!-- 图表容器 -->
        <div id="echartsGrowWrap" class="chartsBody" :style="{ top: (acTab == 0 || acTab == 2) ? '107px' : '88px' }">
        </div>
        <div class="desc">
          <div class="percent">膨果率：{{ acTab < 2 ? '%' : 'g' }}</div>
              <div class="flex-row items-center" style="color:rgba(38, 102, 222, 1);">
                <span
                  :style="{ display: 'block', width: '11px', height: '11px', background: 'rgba(38, 102, 222, 1)', borderRadius: '4px', marginRight: '5px' }"></span>
                <span>{{ acTab == 0 ? real : acTab == 1 ? realJg : realKg }}</span>{{ acTab < 2 ? 'mm' : 'g' }}&nbsp;实际{{
                  acTab == 0 ? '果径' : acTab == 1 ? '干径' : '重量' }} </div>
              </div>
              <div class="wrap">

                <div class="wrap_c">
                  <div class="c_l">
                    <div class="val" v-if="(acTab == 0 || acTab == 2)">膨果率:</div>
                    <div class="per"> {{ acTab == 0 ? '果径值:' : acTab == 1 ? '干径值:' : '重量值:' }}</div>
                  </div>
                  <div class="c_r" :style="{ height: (acTab == 0 || acTab == 2) ? '270px' : '250px' }">
                    <div class="item" v-for="item in fList" :key="item.date">
                      <div class="max" v-if="acTab == 0 || acTab == 2">
                        {{ item.grow }}
                        <img v-if="Number(item.grow) > 0" src="./../../../../assets/images/gree_arrow.jpg" alt="" />
                        <img v-else-if="Number(item.grow) !== 0" src="./../../../../assets/images/red_arrow.jpg" alt="" />
                      </div>
                      <div class="grow"> {{ item.max }} </div>

                      <div class="date">
                        <div>{{ item.shortDate }}</div>
                        <div>{{ item.week }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

          </div>

          <div class="loadingWrap" v-if="loading">
            <van-loading type="spinner" color="#1989fa" />
            <div style="margin-top: 10px; color: #1989fa; font-size: 14px;">数据加载中...</div>
          </div>
        </div>
      </div>
</template>

<script>
import moment from "moment"
import echarts from 'echarts';

const oneDay = 1000 * 60 * 60 * 24 * 1;

export default {
  props: ['farmInfo'],
  data () {
    return {
      no: localStorage.getItem("no") ? localStorage.getItem("no") : "",
      acTab: null,
      chart: null,
      options: {},
      loading: false,
      thlist: [],
      fList: [],
      real: 0,
      realJg: 0,
      realKg: 0,
      option1: null,
      option2: null,
      option3: null,
      today: null,
      sevenDaysAgo: null,
      tabs: [{ key: '0', name: '果径', show: false }, { key: '1', name: '干径', show: false }, { key: '2', name: '重量', show: false }]
    }
  },

  watch: {
    farmInfo: {
      immediate: true,
      deep: true,
      handler (val) {
        if (!this.$isblank(val) && 'myCropList' in val && this.$isblank(this.option2)) {
          this.getFruitPlan(val)
        }
      }
    },
    option1: {
      deep: false,
      handler (val) {
        if (!this.$isblank(val) && 'myCropList' in this.farmInfo && this.$isblank(this.option2) && this.$isblank(this.option3)) {
          this.getFruitPlan(this.farmInfo)
        }
      }
    }
  },



  async mounted () {
    this.chart = echarts.init(document.getElementById('echartsGrowWrap'));
    const currentDate = moment().add(1, 'day').format("YYYY/MM/DD");
    const sevenDaysAgo = moment(currentDate).subtract(7, 'days').format('YYYY/MM/DD');
    const today = currentDate
    this.today = today
    this.sevenDaysAgo = sevenDaysAgo
    await this.getData(this.sevenDaysAgo, this.today,)

    let thlist = JSON.parse(JSON.stringify(this.thlist));

    let maxLengthData = []
    thlist.map(o => {
      if (o.data.length > maxLengthData.length) {
        maxLengthData = [...o.data]
      }
    })

    const fruitList = maxLengthData.filter(o => o.name === '果径')
    const ganList = maxLengthData.filter(o => o.name === '干径')
    const kgList = maxLengthData.filter(o => o.name === '重量')

    console.log("666666:", fruitList, ganList, kgList);

    const tabs = JSON.parse(JSON.stringify(this.tabs))

    tabs[0].show = !!fruitList?.length
    tabs[1].show = !!ganList?.length
    tabs[2].show = !!kgList?.length

    this.tabs = [...tabs]


    const find = this.tabs.find(o => o.show)

    find && this.handleTabsChange(find.key)
  },

  methods: {
    showGrowWrap () { return this.tabs.find(o => o.show) },

    async handleTabsChange (val) {
      this.acTab = val
      this.chart?.clear();
      // 销毁当前的实例
      this.chart.dispose(document.getElementById('echartsGrowWrap'));
      this.chart = echarts.init(document.getElementById('echartsGrowWrap'));

      console.log('切换tab:', this[`option${val}`]);


      if (this[`option${val + 1}`]) {
        this.setValueFList()
        this.chart.setOption(this[`option${val}`]);
      } else {
        await this.getData(this.sevenDaysAgo.replaceAll("-", "/"), this.today.replaceAll("-", "/"))
        await this.getFruitDevice(this.sevenDaysAgo.replaceAll("-", "/"), this.today.replaceAll("-", "/"))
      }
    },

    async getFruitPlan (farmInfo) {
      const id = farmInfo?.myCropList?.[farmInfo?.myCropList?.length - 1]?.id
      if (id == null) return false
      await this.$api.queryPlanFuit(id).then(res => {
        if (res.errcode == 0) {
          const list = res.planFuit
          const temp1 = new Date(this.sevenDaysAgo.replaceAll("-", "/")).getTime()
          const temp2 = new Date(this.today.replaceAll("-", "/")).getTime()

          const xData = [], yData = [];
          const data = []
          list.map(item => {
            if (item.planDate >= temp1 && item.planDate <= temp2) {
              return { ...item, date: moment(item.planDate).format("MM-DD") }
            }
          }).filter(o => o).sort((a, b) => a.planDate - b.planDate).map(item => {
            const _arr = []
            _arr.push(moment(item.planDate).format("MM-DD"), item.planFruitDiam)
            data.push(_arr)
            xData.push(item.planDate)
            yData.push([new Date(item.planDate).getTime(), String(item.planFruitDiam)])
          })

          const _list = this.option1?.series?.[0]?.data || []

          const numList = _list.map(item => { return item[0] })
          xData.map((num, index) => {
            const n = this.findClosestNumber(numList, num)
            yData[index][0] = n
            return n
          })

          if (this.acTab == 0) {
            this.option1.series.push({
              ...this.option1.series[0],
              data: yData,
              name: "计划值",
              symbol: 'circle',  // 设置第二条线的标记符号为圆点
              symbolSize: 4,     // 设置第二条线的标记大小
              showSymbol: true,
            })
            this.option1.legend = {
              data: ["实际果径", "计划值"],
              orient: 'horizontal',  // 将图例设置为垂直方向排列
              left: 'center',        // 设置图例位于容器的左侧
              top: 'bottom',    // 设置图例垂直居中
            }
          }

          this.chart.dispose(document.getElementById('echartsGrowWrap'));
          this.chart = echarts.init(document.getElementById('echartsGrowWrap'));
          this.chart.setOption(this.acTab == 0 ? this.option1 : this.acTab == 1 ? this.option2 : this.option3)
        }
      })
    },
    async getData (time1, time2) {
      this.loading = true
      // 如果天数上大于7天的，则拆分为多个7天的小组 进行请求 然后拼接
      let st = new Date(time1).getTime(),
        et = new Date(time2).getTime();
      let spliceDays = [];
      // 开始时间加上7天时间， 如果小于结束时间

      let days = 7

      if (this.active == 0) { days = 7 }
      else { days = 20 }
      while (st + oneDay * days < et) {
        spliceDays.push({
          sT: this.$setime(st, 2),
          // 7天后的日期
          eT: this.$setime(st + oneDay * days, 2)
        });
        // 加到7天的下一天 就是第8天
        st += oneDay * days + 1
      }

      spliceDays.push({ sT: this.$setime(st, 2), eT: this.$setime(et, 2) });
      let reqList = [];

      spliceDays.map(item => {
        reqList.push(
          this.$api.getLiveList({
            no: this.no,
            startDate: item.sT + " 00:00:00",
            endDate: item.eT + " 23:59:59"
          })
        );
      });
      let dataList = [];

      await Promise.all(reqList)
        .then(res => {
          this.$toast.clear();
          res.map(item => {
            if (!this.$isblank(item.list)) {
              dataList = dataList.concat(item.list);
            }
          });

          if (!this.$isblank(dataList)) {
            var list = [...dataList];
            this.thlist = [...list]
          }

          this.loading = false
        })
        .catch(err => {
          // 其他异常
          this.$toast.clear();
          console.error("err:", err);
          this.loading = false
        });
    },


    setValueFList () {
      let thlist = JSON.parse(JSON.stringify(this.thlist));
      const fruitData = [];
      fruitData.push(this.caculationFruitData(thlist));
      this[this.acTab == 0 ? 'real' : this.acTab == 1 ? 'realJg' : 'realKg'] = fruitData?.[0]?.yData?.[fruitData?.[0]?.yData?.length - 1]?.[1]
      this.fList = [...fruitData[0].data];
      const xData = fruitData[0]?.data?.map(o => o.date) || []
      return { yData: fruitData[0]?.yData, xData }
    },

    // 查询是否有果径传感器
    async getFruitDevice () {
      const { yData, xData } = this.setValueFList()

      this.renderCharts(yData, xData)
    },


    findClosestNumber (arr, A) {
      let minDiff = Number.MAX_SAFE_INTEGER;
      let closestNum;

      // 遍历数组中的每个数字，找到距离 A 最接近的数字
      for (let i = 0; i < arr.length; i++) {
        let diff = Math.abs(arr[i] - A);

        // 如果当前数字与 A 的差值更小，则更新最接近的数字和最小差值
        if (diff < minDiff) {
          minDiff = diff;
          closestNum = arr[i];
        }
      }

      // 返回距离 A 最接近的数字
      return closestNum;
    },


    // 计算多个果径的数据
    caculationFruitData (thlist, tar) {
      this.hasFruit = true;
      // 拿到所有的统计数据  按日期筛选出果径的数据  取最后的7天数据
      let fruitData = [];
      const yData = [];

      thlist.map(o => {
        if (o.data && o.data.length) {
          const t = o.data.find(o => o.name == (this.acTab == 0 ? '果径' : this.acTab == 1 ? '干径' : '重量'));
          if (t) {
            const d = o.gatherDate.split(" ")[0];
            let week = this.$noToChinese(
              new Date(d.replaceAll("-", "/")).getDay()
            );

            if (week === "零" || week === "") { week = "日"; }
            const time = new Date(o.gatherDate.replaceAll("-", "/")).getTime();

            yData.push([time, t.value]);

            const obj = {
              week,
              date: d,
              max: t.value, // 最大值
              grow: 0,
              shortDate: moment(d).format("MM-DD")
            };

            const ind = fruitData.findIndex(k => k.date === obj.date);
            if (ind < 0) {
              fruitData.push(obj);
            } else {
              fruitData[ind].max = Math.max(fruitData[ind].max, t.value);
            }
          }
        }
      });

      fruitData.map((item, index) => {
        const none = ["null", "NaN", null, NaN, undefined, ''];
        if (none.includes(item.max)) {
          item.max = "";
          item.grow = "";
        } else {
          if (index !== 0) {
            item.grow = (item.max - fruitData[index - 1].max).toFixed(this.acTab == 0 ? 2 : 1);
          }
        }
      });

      // 删除掉第一条的，第一条的数据只是为了计算一周时间内  第一天的 grow 成长值
      // fruitData.shift();

      // 如果长度大于7 取7条 如果长度小于7 取全部
      if (fruitData > 7) {
        fruitData = {
          data: [...fruitData.reverse().slice(0, 7)],
          yData
        };
      } else {
        fruitData = { data: [...fruitData], yData, name: this.acTab == 0 ? '果径' : this.acTab == 1 ? '干径' : '重量' };
      }

      return fruitData;
    },

    renderCharts (yData, xData) {
      this.loading = true
      const data = JSON.parse(JSON.stringify(yData));
      const fillFullData = data.map((o) => o && !o === "null").filter((o) => o);
      fillFullData.sort((a, b) => a - b);

      yData.push([new Date(xData[0] + " 00:00:00").getTime() - oneDay, null])
      yData.push([new Date(xData[xData.length - 1] + " 00:00:00").getTime() + oneDay, null])


      const option = {
        tooltip: { trigger: "axis", },
        grid: { top: "18px", bottom: "30%", left: "13.8%", right: '17px', },
        xAxis: {
          type: "time",
          show: true,
          boundaryGap: false,
          splitNumber: 7,
          axisLine: { lineStyle: { color: "#1B2232", }, },
          min: xData[0],  // 设置 X 轴的最小值为 09/02
          max: moment(new Date(xData[xData.length - 1].replaceAll("-", '/') + " 00:00:00").getTime() + oneDay).format("YYYY-MM-DD"), // 设置 X 轴的最大值为 09/09
          minInterval: oneDay, // 24小时分割
          axisLabel: {
            show: false,
            interval: 0,
            formatter: function (value, index) {
              var date = new Date(value);
              var day = date.getDate();
              if (day >= 2 && day <= 9) {
                return moment(value).format('MM/DD');
              } else {
                return '';
              }
            },
            color: "#1B2232",
            length: 0 // 将刻度线的长度设置为 0，隐藏刻度线
          },
          axisTick: {
            show: false,
            interval: 0, // 设置刻度线显示间隔为 0
          }
        },


        yAxis: {
          name: "",
          nameTextStyle: { color: "#1B2232", },
          type: "value",
          boundaryGap: [0, "100%"],
          splitLine: { show: false, },
          axisLine: {
            lineStyle: {
              show: false, width: 0.1, // 0.1的线条是非常细的了。
              type: "solid",
              color: "#1B2232",
            },
          },
          axisLabel: {
            color: "#1B2232",
          },
          min: function (value) { return value.min; },
          max: function (value) { return value.max; },
        },
        series: [
          {
            showSymbol: false,
            name: this.acTab == 0 ? "实际果径" : this.acTab == 1 ? '实际干径' : "实际重量",
            type: "line",
            hoverAnimation: true,
            smooth: true,
            symbolSize: 4,
            data: yData,
            markPoint: {
              label: {
                show: true,
                position: "top",
                distance: 10,
                offset: [0, 10],
                // formatter: "{b}:\n{c}",
              },
              symbol: "circle",
              symbolSize: 12,
              symbolOffset: [0, 0],
              data: [
                { type: "min", name: "最小值" },
                { type: "max", name: "最大值" },
              ],
            },
            // xAxisIndex: 0,  // 指定使用第一个 x 轴数据
          },
        ],
      };



      if (this.acTab == 0) {
        this.option1 = { ...option }
      } else if (this.acTab == 1) {
        option.legend = {
          data: ["实际干径"],
          orient: 'horizontal',  // 将图例设置为垂直方向排列
          left: 'center',        // 设置图例位于容器的左侧
          top: 'bottom',    // 设置图例垂直居中
        }
        this.option2 = { ...option }
        this.chart.dispose(document.getElementById('echartsGrowWrap'));
        this.chart = echarts.init(document.getElementById('echartsGrowWrap'));
      } else {
        option.legend = {
          data: ["实际重量"],
          orient: 'horizontal',  // 将图例设置为垂直方向排列
          left: 'center',        // 设置图例位于容器的左侧
          top: 'bottom',    // 设置图例垂直居中
        }


        this.option3 = { ...option }
        this.chart.dispose(document.getElementById('echartsGrowWrap'));
        this.chart = echarts.init(document.getElementById('echartsGrowWrap'));
      }


      this.chart.setOption(option);
      this.loading = false;
    },

    date (time) {
      return new Date(time.replaceAll("-", "/")).getTime();
    },
  },

}
</script>

<style lang="scss"  scoped>
@import "./../../codeFunCommon.scss";

.container {
  width: 100%;
  background: #ffffff;
}

.tabs {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;

  .title {
    position: absolute;
    width: 65px;
  }

  .tabWrap {
    width: calc(100% - 65px);
    margin-left: 65px;
  }

  ::v-deep .van-tabs__line {
    background: #3364db;
  }
}

.body {
  position: relative;
  min-height: 200px;
  padding: 10px;
  margin-bottom: 20px;
}

.loadingWrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  opacity: 0.5;
  background: rgba(255, 255, 255, 0.5);
  align-items: center;
  justify-content: center;
}

.wrap_c {
  display: flex;

  .c_l {
    width: 40px;
    font-size: 12px;

    .val {
      padding-top: 15px;
      line-height: 12px;
    }

    .per {
      padding-bottom: 5px;
      padding-top: 15px;
      line-height: 12px;
    }
  }

  .c_r {
    position: relative;
    display: flex;
    width: calc(100% - 40px);
    // height: 300px;
    height: 240px;
    font-size: 12px;
    flex-wrap: wrap;
    padding-right: 17px;

    .item {
      position: relative;
      flex: 1;
      text-align: center;

      &:nth-child(2n - 1) {
        // background-color: rgba(225, 225, 225, 0.8);
        background: linear-gradient(180deg,
            rgba(42, 133, 255, 0.3) 0%,
            rgba(42, 133, 255, 0.0001) 100%);
      }

      .max {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 15px;
        line-height: 12px;
        color: rgba(255, 85, 85, 1);
      }

      .grow {
        padding-top: 15px;
        padding-bottom: 5px;
        line-height: 12px;
      }

      img {
        width: 4px;
        height: 14px;
      }

      .date {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 25px;
        width: 100%;
        text-align: center;
      }
    }
  }
}

.chartsBody {
  position: absolute;
  top: 135px;
  left: -5px;
  width: calc(100% - 5px);
  height: 200px;
  border-top: none;
  box-sizing: border-box;
  z-index: 100;
}

.desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;

  .percent {
    color: rgba(255, 85, 85, 1);
  }
}
</style>
